<template>
<div id="drone-result-graph-page">
  <div class="d-flex justify-end">
    <div class="mx-8 my-4">
      <div class="d-flex justify-end">
        <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
      </div>
      <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
    </div>
  </div>
  <div class="ma-10 mt-0" style="height: 930px;">
    <div class="d-flex justify-start mb-3">
      <span class="font-weight-bold text-h5 my-auto mr-4" style="height: 40px;">故障モード別原因の割合</span>
    </div>
    <v-row class="mb-16">
      <v-col cols="6">
        <apexchart type="pie" :options="chartCellErrorReasonOptions" :series="cellErrorReason" v-if="showChartCell"></apexchart>
      </v-col>
      <v-col cols="6">
        <apexchart type="pie" :options="chartMulticellErrorReasonOptions" :series="multicellErrorReason" v-if="showChartMulticell"></apexchart>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <apexchart type="pie" :options="chartClusterErrorReasonOptions" :series="clusterErrorReason" v-if="showChartCluster"></apexchart>
      </v-col>
      <v-col cols="6">
        <apexchart type="pie" :options="chartModuleErrorReasonOptions" :series="moduleErrorReason" v-if="showChartModule"></apexchart>
      </v-col>
    </v-row>
  </div>
  <div class="mr-8">
    <div class="d-flex align-end justify-end">
      <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
      <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">{{naviVisibleList.findIndex(item => item.text === 'ドローン検査結果') + 3}}/{{naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
    </div>
    <div class="d-flex align-end justify-end">
      <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "DroneResultGraphPage",
  props: ['report', 'naviVisibleList', 'cropImagePageNum', 'editMode', 'pdfPageNum'],
  data(){
    return {
      droneResult: {
        'length': 0,
        'cell': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null
        },
        'multicell': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null
        },
        'cluster': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null
        },
        'module': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null
        },
        'string': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null
        },
        'junction': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null
        },
        'pid': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null
        },
        'shadow': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null
        },
      },
      folderId: this.$route.params.folderId,
      chartClusterErrorReasonOptions: {
        colors : ['#4CAF50', '#2196F3', '#FF9800', '#9E9E9E'],
        labels: ['割れ', '堆積物', '植生', '不明'],
        title: {
          text: 'クラスタバイパス',
          align: 'center',
          margin: 0,
          style: {
            fontWeight: 'normal'
          }
        },
        legend: {
          show: true,
          // showForNullSeries: false,
          formatter: function (val, opts) {
            if (opts.w.globals.seriesPercent[opts.seriesIndex]){
              if (opts.w.globals.seriesPercent[opts.seriesIndex][0]){
                if (opts.w.globals.seriesPercent[opts.seriesIndex][0] < 0.01 && opts.w.globals.seriesPercent[opts.seriesIndex][0] > 0){
                  return val + " - " + opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(1-Math.floor(Math.log(opts.w.globals.seriesPercent[opts.seriesIndex][0])/Math.log(10))) + '%'
                }
                return val + " - " + Math.round(opts.w.globals.seriesPercent[opts.seriesIndex][0] * 100) / 100 + '%'
              }
            }
            return val + " - " + 0 + '%'
          }
        },
        noData: {
          text: '該当なし',
          align: 'center',
          verticalAlign: 'top',
          offsetY: 10,
          style: {
            fontSize: '20px',
          }
        }
      },
      chartMulticellErrorReasonOptions: {
        colors : ['#4CAF50', '#2196F3', '#FF9800', '#9E9E9E'],
        labels: ['割れ', '堆積物', '植生', '不明'],
        title: {
          text: 'マルチホットスポット',
          align: 'center',
          margin: 0,
          style: {
            fontWeight: 'normal'
          }
        },
        legend: {
          show: true,
          // showForNullSeries: false,
          formatter: function (val, opts) {
            if (opts.w.globals.seriesPercent[opts.seriesIndex]){
              if (opts.w.globals.seriesPercent[opts.seriesIndex][0]){
                if (opts.w.globals.seriesPercent[opts.seriesIndex][0] < 0.01 && opts.w.globals.seriesPercent[opts.seriesIndex][0] > 0){
                  return val + " - " + opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(1-Math.floor(Math.log(opts.w.globals.seriesPercent[opts.seriesIndex][0])/Math.log(10))) + '%'
                }
                return val + " - " + Math.round(opts.w.globals.seriesPercent[opts.seriesIndex][0] * 100) / 100 + '%'
              }
            }
            return val + " - " + 0 + '%'
          }
        },
        noData: {
          text: '該当なし',
          align: 'center',
          verticalAlign: 'top',
          offsetY: 10,
          style: {
            fontSize: '20px',
          }
        }
      },
      chartCellErrorReasonOptions: {
        colors : ['#4CAF50', '#2196F3', '#FF9800', '#9E9E9E'],
        labels: ['割れ', '堆積物', '植生', '不明'],
        title: {
          text: 'ホットスポット',
          align: 'center',
          margin: 0,
          style: {
            fontWeight: 'normal'
          }
        },
        legend: {
          show: true,
          // showForNullSeries: false,
          formatter: function (val, opts) {
            if (opts.w.globals.seriesPercent[opts.seriesIndex]){
              if (opts.w.globals.seriesPercent[opts.seriesIndex][0]){
                if (opts.w.globals.seriesPercent[opts.seriesIndex][0] < 0.01 && opts.w.globals.seriesPercent[opts.seriesIndex][0] > 0){
                  return val + " - " + opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(1-Math.floor(Math.log(opts.w.globals.seriesPercent[opts.seriesIndex][0])/Math.log(10))) + '%'
                }
                return val + " - " + Math.round(opts.w.globals.seriesPercent[opts.seriesIndex][0] * 100) / 100 + '%'
              }
            }
            return val + " - " + 0 + '%'
          }
        },
        noData: {
          text: '該当なし',
          align: 'center',
          verticalAlign: 'top',
          offsetY: 10,
          style: {
            fontSize: '20px',
          }
        }
      },
      chartModuleErrorReasonOptions: {
        colors : ['#4CAF50', '#2196F3', '#FF9800', '#9E9E9E'],
        labels: ['割れ', '堆積物', '植生', '不明'],
        title: {
          text: 'モジュール異常',
          align: 'center',
          margin: 0,
          style: {
            fontWeight: 'normal'
          }
        },
        legend: {
          show: true,
          // showForNullSeries: false,
          formatter: function (val, opts) {
            if (opts.w.globals.seriesPercent[opts.seriesIndex]){
              if (opts.w.globals.seriesPercent[opts.seriesIndex][0]){
                if (opts.w.globals.seriesPercent[opts.seriesIndex][0] < 0.01 && opts.w.globals.seriesPercent[opts.seriesIndex][0] > 0){
                  return val + " - " + opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(1-Math.floor(Math.log(opts.w.globals.seriesPercent[opts.seriesIndex][0])/Math.log(10))) + '%'
                }
                return val + " - " + Math.round(opts.w.globals.seriesPercent[opts.seriesIndex][0] * 100) / 100 + '%'
              }
            }
            return val + " - " + 0 + '%'
          }
        },
        noData: {
          text: '該当なし',
          align: 'center',
          verticalAlign: 'top',
          offsetY: 10,
          style: {
            fontSize: '20px',
          }
        }
      },
      clusterErrorReason: [],
      multicellErrorReason: [],
      cellErrorReason: [],
      moduleErrorReason: [],
      showChartCell: false,
      showChartMulticell: false,
      showChartModule: false,
      showChartCluster: false
    }
  },
  methods: {
    calculateErrorPercentage(val){
      if (val > 0){
        this.droneResult['shadow'].errorPercentage = this.droneResult['shadow'].errorNum/val*100;
        if (this.droneResult['shadow'].errorPercentage < 0.01 && this.droneResult['shadow'].errorPercentage > 0){
          this.droneResult['shadow'].errorPercentage = this.droneResult['shadow'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['shadow'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['shadow'].errorPercentage = Number(this.droneResult['shadow'].errorNum/val*100).toFixed(2);
        }

        this.droneResult['cell'].errorPercentage = this.droneResult['cell'].errorNum/val*100;
        if (this.droneResult['cell'].errorPercentage < 0.01 && this.droneResult['cell'].errorPercentage > 0){
          this.droneResult['cell'].errorPercentage = this.droneResult['cell'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['cell'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['cell'].errorPercentage = Number(this.droneResult['cell'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['multicell'].errorPercentage = this.droneResult['multicell'].errorNum/val*100;
        if (this.droneResult['multicell'].errorPercentage < 0.01 && this.droneResult['multicell'].errorPercentage > 0){
          this.droneResult['multicell'].errorPercentage = this.droneResult['multicell'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['multicell'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['multicell'].errorPercentage = Number(this.droneResult['multicell'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['cluster'].errorPercentage = this.droneResult['cluster'].errorNum/val*100;
        if (this.droneResult['cluster'].errorPercentage < 0.01 && this.droneResult['cluster'].errorPercentage > 0){
          this.droneResult['cluster'].errorPercentage = this.droneResult['cluster'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['cluster'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['cluster'].errorPercentage = Number(this.droneResult['cluster'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['module'].errorPercentage = this.droneResult['module'].errorNum/val*100;
        if (this.droneResult['module'].errorPercentage < 0.01 && this.droneResult['module'].errorPercentage > 0){
          this.droneResult['module'].errorPercentage = this.droneResult['module'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['module'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['module'].errorPercentage = Number(this.droneResult['module'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['junction'].errorPercentage = this.droneResult['junction'].errorNum/val*100;
        if (this.droneResult['junction'].errorPercentage < 0.01 && this.droneResult['junction'].errorPercentage > 0){
          this.droneResult['junction'].errorPercentage = this.droneResult['junction'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['junction'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['junction'].errorPercentage = Number(this.droneResult['junction'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['pid'].errorPercentage = this.droneResult['pid'].errorNum/val*100;
        if (this.droneResult['pid'].errorPercentage < 0.01 && this.droneResult['pid'].errorPercentage > 0){
          this.droneResult['pid'].errorPercentage = this.droneResult['pid'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['pid'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['pid'].errorPercentage = Number(this.droneResult['pid'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['string'].errorPercentage = Number(0).toFixed(2);
        if (this.report.stringErrorModuleNum && this.droneResult['string'].errorNum > 0){
          this.droneResult['string'].errorPercentage = this.report.stringErrorModuleNum/val * 100;
          if (this.droneResult['string'].errorPercentage < 0.01 && this.droneResult['string'].errorPercentage > 0){
            this.droneResult['string'].errorPercentage = this.droneResult['string'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['string'].errorPercentage)/Math.log(10)));
          }
          else {
            this.droneResult['string'].errorPercentage = Number(this.report.stringErrorModuleNum/val * 100).toFixed(2);
          }
        }
        // this.droneResult['string'].errorPercentage = Math.round(this.droneResult['string'].errorNum/val*10000)/100;
        const data = [
          this.droneResult['cell'].errorPercentage,
          this.droneResult['multicell'].errorPercentage,
          this.droneResult['cluster'].errorPercentage,
          this.droneResult['module'].errorPercentage,
          this.droneResult['string'].errorPercentage
        ];
        if (this.droneResult['junction'].errorPercentage > 0){
          data.push(this.droneResult['junction'].errorPercentage);
        }
        if (this.droneResult['pid'].errorPercentage > 0){
          data.push(this.droneResult['pid'].errorPercentage);
        }
        this.errorPercentage = [{
          name: 'エラー',
          data: data
        }];
      }
      else{
        this.errorPercentage = [{
          name: 'エラー',
          data: [0, 0, 0, 0, 0]
        }];
      }
    },
    checkErrorReason(errorReason){
      if (errorReason.every(item => item === 0)){
        errorReason = [];
      }
    },
    reset(){
      this.droneResult = {
        'length': 0,
            'cell': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null
        },
        'multicell': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null
        },
        'cluster': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null
        },
        'module': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null
        },
        'string': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null
        },
        'junction': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null
        },
        'pid': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null
        },
        'shadow': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null
        },
      };
    },
    init(){
      const panelErrorTypes = this.report.filter.panel_error_types;
      // const panelErrorReasons = this.report.filter.panel_error_reasons;
      const annotationList = this.annotation.panel_abnormality.list.filter(item => {
        let check = true;
        if (panelErrorTypes.length > 0){
          if (item.type){
            check = check && panelErrorTypes.findIndex(error => error === item.type) >= 0;
          }
          else {
            check = check && panelErrorTypes.findIndex(error => error === 'undefined') >= 0;
          }
        }
        else {
          return false;
        }
        return check;
      });
      annotationList.forEach(item => {
        this.report[item.type] = true;
        this.droneResult.length++;
        this.droneResult[item.type].errorReasonNum.length++;
        this.droneResult[item.type].errorNum++;
        if (item.reason){
          this.droneResult[item.type].errorReasonNum[item.reason]++;
        }
        else {
          this.droneResult[item.type].errorReasonNum['unknown']++;
        }
      });
      this.calculateErrorPercentage(this.report.plantModuleNum);

      this.clusterErrorReason = [this.droneResult['cluster'].errorReasonNum.crack, this.droneResult['cluster'].errorReasonNum.sediment, this.droneResult['cluster'].errorReasonNum.vegetation, this.droneResult['cluster'].errorReasonNum.unknown]
      if (this.clusterErrorReason.every(item => item === 0)){
        this.clusterErrorReason = [];
        this.chartClusterErrorReasonOptions.legend['showForNullSeries'] = false;
      }
      this.showChartCluster = true;

      this.multicellErrorReason = [this.droneResult['multicell'].errorReasonNum.crack, this.droneResult['multicell'].errorReasonNum.sediment, this.droneResult['multicell'].errorReasonNum.vegetation, this.droneResult['multicell'].errorReasonNum.unknown]
      if (this.multicellErrorReason.every(item => item === 0)){
        this.multicellErrorReason = [];
        this.chartMulticellErrorReasonOptions.legend['showForNullSeries'] = false;
      }
      this.showChartMulticell = true;

      this.cellErrorReason = [this.droneResult['cell'].errorReasonNum.crack, this.droneResult['cell'].errorReasonNum.sediment, this.droneResult['cell'].errorReasonNum.vegetation, this.droneResult['cell'].errorReasonNum.unknown]
      if (this.cellErrorReason.every(item => item === 0)){
        this.cellErrorReason = [];
        this.chartCellErrorReasonOptions.legend['showForNullSeries'] = false;
      }
      this.showChartCell = true;

      this.moduleErrorReason = [this.droneResult['module'].errorReasonNum.crack, this.droneResult['module'].errorReasonNum.sediment, this.droneResult['module'].errorReasonNum.vegetation, this.droneResult['module'].errorReasonNum.unknown]
      if (this.moduleErrorReason.every(item => item === 0)){
        this.moduleErrorReason = [];
        this.chartModuleErrorReasonOptions.legend['showForNullSeries'] = false;
      }
      this.showChartModule = true;
    }
  },
  created() {
    this.axios
        .get('/api/annotation/' + this.folderId)
        .then((response) => {
          this.annotation = response.data.annotation;
          this.reset();
          this.init();
        });
  },
  watch:{
    'report.plantModuleNum': function (val) {
      this.calculateErrorPercentage(val);
    },
    // 'report.stringErrorModuleNum': function (val) {
    //   if (val && this.report.plantModuleNum && this.droneResult['string'].errorNum > 0){
    //     this.droneResult['string'].errorPercentage = Number(val/this.report.plantModuleNum*100).toFixed(2);
    //   }
    //   else {
    //     this.droneResult['string'].errorPercentage = Number(0).toFixed(2);
    //   }
    //   const data = JSON.parse(JSON.stringify(this.errorPercentage[0].data));
    //   data[4] = this.droneResult['string'].errorPercentage;
    //   this.errorPercentage = [{
    //     name: 'エラー',
    //     data: data
    //   }];
    // }
    'report.filter': function (){
      this.reset();
      this.init();
    }
  }
}
</script>

<style scoped>

</style>
